<template>
  <v-container>
    <v-row v-if="!userData" class="menu-row">
      <v-col cols="12">
        <div class="menu-section">
          <div >
            <div class="menu-headline">
              <v-icon class="menu-icon" color="green">mdi-account-plus</v-icon>
              <p class="menu-title mb-0">Account anlegen</p>
            </div>
            <div class="menu-tags menu-tags--block pl-4">
              <router-link class="menu-tag" to="/login">Jetzt kostenlos anmelden</router-link>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row class="menu-row">
      <v-col cols="12">
        <div class="menu-section">
          <div >
            <div class="menu-headline">
              <v-icon class="menu-icon" color="green">mdi-book-open-variant</v-icon>
              <p class="menu-title mb-0">WaizmannTabellen</p>
            </div>
            <div class="menu-tags menu-tags--block pl-4">
              <router-link class="menu-tag" to="/waizmanntabellen_bestellen">
                ToGo & Gesamtausgabe bestellen
              </router-link>
              <router-link class="menu-tag" to="/info/Digitalausgabe">
                Digitalausgabe
              </router-link>
              <router-link class="menu-tag" to="/info/Download">
                Download für E-Mail
              </router-link>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row class="menu-row">
      <v-col cols="12">
        <div class="menu-section">
          <div>
            <div class="menu-headline">
              <v-icon class="menu-icon top-aligned" color="green">mdi-new-box</v-icon>
              <p class="menu-title mb-0">
                <span class="menu-title__smaller">SmileFile</span><br>
                <span class="menu-title__emphasis">Abrechnungsplan</span>
              </p>
            </div>
            <div class="pl-4">
              <p class="menu-subtitle mb-0">
                Der SmileFile Abrechnungsplan zeigt Ihnen, welche Leistungen in den ersten Versicherungsjahren wann und in welcher Höhe abrechenbar sind.
                Für Kunden der WaizmannTabelle kostenlos.
              </p>
              <a
                class="menu-link mt-2 d-inline-flex align-center"
                href="https://www.smillefile.info"
                target="_blank"
                rel="noopener"
              >
                www.smillefile.info
                <v-icon size="16" class="ml-1">mdi-open-in-new</v-icon>
              </a>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    

    <!-- <v-row class="menu-row">
      <v-col cols="12">
        <router-link class="menu-section menu-section--clickable" to="/webinar/5">
          <div >
            <div class="menu-headline tight align-start">
              <v-icon class="menu-icon top-aligned" color="orange">mdi-lightbulb-on-outline</v-icon>
              <div>
                <p class="menu-eyebrow text-green mb-0">Experten-Webinar</p>
                <p class="menu-title mb-0">"KI in der Zahnarztpraxis!"</p>
              </div>
            </div>
            <div class="pl-4">
              <p class="menu-subtitle mb-0">
                In 20 Minuten erfahren Sie, wie Sie KI sinnvoll in Ihre Praxis integrieren – inklusive
                Dozenten-Insights von Dr. Marc Elstner.
              </p>
              <span class="menu-link  mt-2 d-inline-flex align-center">
                jetzt anmelden
                <v-icon size="16" class="ml-1">mdi-open-in-new</v-icon>
              </span>
            </div>
          </div>
        </router-link>
      </v-col>
    </v-row> -->

    <!-- <v-row class="menu-row">
      <v-col cols="12">
        <div class="menu-section">
          <div class="menu-item menu-item--stacked">
            <div class="menu-headline">
              <v-icon class="menu-icon" color="purple">mdi-school</v-icon>
              <p class="menu-title mb-0">Praxiswissen ZZV</p>
            </div>
            <div class="menu-tags">
              <router-link class="menu-tag" to="/praxiswissen/Prophylaxe">Prophylaxe</router-link>
              <router-link class="menu-tag" to="/praxiswissen/AngerateneBehandlung">
                Angeratene Behandlung
              </router-link>
              <router-link class="menu-tag" to="/praxiswissen/FehlendeZaehne">Fehlende Zähne</router-link>
            </div>
          </div>
        </div>
      </v-col>
    </v-row> -->

    <v-row class="menu-row" v-if="userData">
      <v-col cols="12">
        <div class="menu-section">
          <div class="menu-tags">
              <router-link class="menu-tag" to="/account">Adresse bearbeiten</router-link>
              <router-link class="menu-tag" to="/account/password">Passwort ändern</router-link>

          </div>
        </div>
      </v-col>
    </v-row>
   
  </v-container>
</template>

<script setup>
import { inject } from 'vue';
import { storeToRefs } from 'pinia';

const userStore = inject('userStore');
const { userData } = storeToRefs(userStore);

</script>

<style scoped>
.menu-row + .menu-row {
  padding-top: 10px;
}

.menu-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 12px 0;
  cursor: pointer;
  transition: color 0.2s ease;
}

.menu-item:hover .menu-title,
.menu-item:hover .menu-link {
  color: #1f3a63;
}

.menu-item--stacked {
  flex-direction: column;
  align-items: flex-start;
}

.menu-headline {
  display: flex;
  align-items: center;
  gap: 8px;
}
.menu-headline.tight {
  margin-bottom: 4px;
}
.menu-headline.align-start {
  align-items: flex-start;
}

.menu-icon {
  font-size: 24px;
  margin-top: 6px;
}
.menu-icon.top-aligned {
  margin-top: 4px;
}

.mb-0 {
  margin-bottom: 0;
}

.menu-title {
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  color: #1f3a63;
}
.menu-title__emphasis {
  font-size: 20px;
  font-weight: 700;
}
.menu-title__smaller {
  font-size: 16px;
  font-weight: 600;
  margin-right: 4px;
}
.menu-subtitle {
  margin: 8px 0;
  color: #4a5568;
}
.menu-subtitle.mb-0 {
  margin-bottom: 0;
}
.menu-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.menu-section--clickable {
  display: block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  padding: 12px 0;
}
.menu-section--clickable:focus-visible {
  outline: 2px solid #2e7d32;
  outline-offset: 4px;
  border-radius: 8px;
}

.menu-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #3166a5;
  text-decoration: none;
  font-weight: 600;
  margin-right: 12px;
}

.menu-link.primary {
  color: #2e7d32;
}

.menu-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.menu-tag {
  padding: 4px 12px;
  border-radius: 4px;
  background: #f2f6fb;
  color: #1f3a63;
  text-decoration: none;
  font-weight: 600;
}

.menu-tags--block {
  flex-direction: column;
  align-items: flex-start;
}
</style>

